// import React, { useState, useEffect } from 'react';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import Header from '../Components/Header';
// import { Spinner } from 'react-bootstrap'; // Import Spinner from react-bootstrap for the loading indicator

// const RegisterCustomer = () => {
//   const [agentId, setAgentId] = useState('');
//   const [name, setName] = useState('');
//   const [mobileNo, setMobileNo] = useState('');
//   const [cnic, setCnic] = useState('');
//   const [status, setStatus] = useState('Transfer'); // Default status to Transfer
//   const [gender, setGender] = useState(''); // Initially empty, should be selected
//   const [packageId, setPackageId] = useState(''); // Initially empty, should be selected
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(false); // Loading state to show spinner

//   // Fetch user data from sessionStorage when the component loads
//   useEffect(() => {
//     const storedUserData = sessionStorage.getItem('user');
//     if (storedUserData) {
//       const userData = JSON.parse(storedUserData);
//       setAgentId(userData.userId); // Set userId as agentId
//       console.log('User ID retrieved from sessionStorage:', userData.userId); // Debugging output

//       // Call API to fetch packages for this agent
//       axios.get(`https://retailportalapi.webddocsystems.com/RetailAgentGetPackage?id=${userData.userId}`)
//         .then(response => {
//           if (response.data.responseCode === "0000") {
//             setPackages(response.data.packages);  // Set the packages data to state
//           } else {
//             Swal.fire('Error', 'Failed to load packages.', 'error');
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching packages:', error);
//           Swal.fire('Error', 'An error occurred while fetching packages.', 'error');
//         });
//     } 
//     else {
//       console.error('No user data found in sessionStorage');
//     }
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Initialize an array to collect all errors
//     let errorMessages = [];

//     // Check for missing fields and add respective messages to the array
//     if (!name) errorMessages.push("Name is required.");
//     if (!mobileNo) errorMessages.push("Mobile Number is required.");
//     if (!cnic) errorMessages.push("CNIC is required.");
//     if (!status) errorMessages.push("Status is required.");
//     if (!gender) errorMessages.push("Gender is required.");
//     if (!packageId) errorMessages.push("Package is required.");

//     // If there are any errors, show the alerts and stop submission
//     if (errorMessages.length > 0) {
//       Swal.fire('Error', errorMessages.join('\n'), 'error');
//       return;
//     }

//     setLoading(true); // Set loading to true when the submit starts

//     try {
//       const response = await axios.post('https://retailportalapi.webddocsystems.com/Retail_RegisterCustomerNo', {
//         agentId,  // This comes from sessionStorage
//         name,
//         mobileNo,
//         cnic,
//         status,
//         gender,
//         packageid: packageId
//       }, {
//         headers: {
//           'Accept': '*/*',
//           'Content-Type': 'application/json',
//         }
//       });

//       setLoading(false); // Set loading to false once the response is received

//       if (response.data.responseCode === "0000") {
//         Swal.fire({
//           icon: 'success',
//           title: 'Customer Registered',
//           text: response.data.message,
//         });

//         // Reset the form after successful registration
//         setAgentId('');
//         setName('');
//         setMobileNo('');
//         setCnic('');
//         setStatus('Transfer');
//         setGender('');
//         setPackageId('');
//       } else {
//         Swal.fire('Error', response.data.message, 'error');
//       }
//     } catch (error) {
//       setLoading(false); // Set loading to false if an error occurs
//       console.error('Error during registration:', error);
//       Swal.fire('Error', 'An error occurred. Please try again later.', 'error');
//     }
//   };

//   return (
//     <>
//       <Header />

//       <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '90vh' }}>
//         <div className="row justify-content-center w-100">
//           <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4 col-xxxl-3">
//             <div className="card shadow-sm">
//               <div className="card-body">
//                 <div className="text-center mb-4">
//                   <h4>Register Customer</h4>
//                 </div>

//                 <form onSubmit={handleSubmit}>
//                   <div className="mb-3">
//                     <input
//                       type="hidden"
//                       className="form-control"
//                       id="agentId"
//                       placeholder="Agent ID"
//                       value={agentId}
//                       disabled // Agent ID is auto-filled from the logged-in user data
//                     />
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="name" className="form-label">Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="name"
//                       placeholder="Enter Customer Name"
//                       value={name}
//                       onChange={(e) => setName(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="mobileNo" className="form-label">Mobile No</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="mobileNo"
//                       placeholder="Enter Mobile No"
//                       value={mobileNo}
//                       onChange={(e) => setMobileNo(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="cnic" className="form-label">CNIC</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="cnic"
//                       placeholder="Enter CNIC"
//                       value={cnic}
//                       onChange={(e) => setCnic(e.target.value)}
//                       required
//                     />
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="status" className="form-label">Status</label>
//                     <select
//                       className="form-select"
//                       id="status"
//                       value={status}
//                       onChange={(e) => setStatus(e.target.value)}
//                       required
//                     >
//                       <option value="Transfer">Transfer</option>
//                       <option value="Rejected">Rejected</option>
//                     </select>
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="gender" className="form-label">Gender</label>
//                     <select
//                       className="form-select"
//                       id="gender"
//                       value={gender}
//                       onChange={(e) => setGender(e.target.value)}
//                       required
//                     >
//                       <option value="">Select Gender</option>
//                       <option value="Male">Male</option>
//                       <option value="Female">Female</option>
//                       <option value="Other">Other</option>
//                     </select>
//                   </div>

//                   <div className="mb-3">
//                     <label htmlFor="packageId" className="form-label">Package</label>
//                     <select
//                       className="form-select"
//                       id="packageId"
//                       value={packageId}
//                       onChange={(e) => setPackageId(e.target.value)}
//                       required
//                     >
//                       <option value="">Select Package</option>
//                       {packages.map(pkg => (
//                         <option key={pkg.packageid} value={pkg.packageid}>
//                           {pkg.packageName} in Rs.{pkg.packagePrice}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="d-grid gap-2 mt-4">
//                     <button 
//                       type="submit" 
//                       className="btn btn-primary" 
//                       disabled={loading} // Disable the button while loading
//                     >
//                       {loading ? (
//                         <><Spinner animation="border" size="sm" /> Registering...</> // Show spinner during submission
//                       ) : (
//                         'Register Customer'
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
  
// };

// export default RegisterCustomer;


import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import Header from '../Components/Header';
import { Spinner } from 'react-bootstrap'; // Import Spinner from react-bootstrap for the loading indicator

const RegisterCustomer = () => {
  const [agentId, setAgentId] = useState('');
  const [name, setName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [cnic, setCnic] = useState('');
  const [status, setStatus] = useState('Transfer'); // Default status to Transfer
  const [gender, setGender] = useState(''); // Initially empty, should be selected
  const [packageId, setPackageId] = useState(''); // Initially empty, should be selected
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state to show spinner

  // Fetch user data from sessionStorage when the component loads
  useEffect(() => {
    const storedUserData = sessionStorage.getItem('user');
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setAgentId(userData.userId); // Set userId as agentId
      console.log('User ID retrieved from sessionStorage:', userData.userId); // Debugging output

      // Call API to fetch packages for this agent
      axios.get(`https://retailportalapi.webddocsystems.com/RetailAgentGetPackage?id=${userData.userId}`)
        .then(response => {
          if (response.data.responseCode === "0000") {
            setPackages(response.data.packages);  // Set the packages data to state
          } else {
            Swal.fire('Error', 'Failed to load packages.', 'error');
          }
        })
        .catch(error => {
          console.error('Error fetching packages:', error);
          Swal.fire('Error', 'An error occurred while fetching packages.', 'error');
        });
    } else {
      console.error('No user data found in sessionStorage');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Initialize an array to collect all errors
    let errorMessages = [];

    // Check for missing fields and add respective messages to the array
    if (!name) errorMessages.push("Name is required.");
    if (!mobileNo) errorMessages.push("Mobile Number is required.");
    if (!cnic) errorMessages.push("CNIC is required.");
    if (!status) errorMessages.push("Status is required.");
    if (!gender) errorMessages.push("Gender is required.");
    if (!packageId) errorMessages.push("Package is required.");

    // If there are any errors, show the alerts and stop submission
    if (errorMessages.length > 0) {
      Swal.fire('Error', errorMessages.join('\n'), 'error');
      return;
    }

    setLoading(true); // Set loading to true when the submit starts

    try {
      const response = await axios.post('https://retailportalapi.webddocsystems.com/Retail_RegisterCustomerNo', {
        agentId,  // This comes from sessionStorage
        name,
        mobileNo,
        cnic,
        status,
        gender,
        packageid: packageId
      }, {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        }
      });

      setLoading(false); // Set loading to false once the response is received

      if (response.data.responseCode === "0000") {
        Swal.fire({
          icon: 'success',
          title: 'Customer Registered',
          text: response.data.message,
        });


        //added this line
        // Reset the form after successful registration
        setName('');
        setMobileNo('');
        setCnic('');
        setStatus('Transfer');
        setGender('');
        setPackageId('');
      } else {
        Swal.fire('Error', response.data.message, 'error');
      }
    } catch (error) {
      setLoading(false); // Set loading to false if an error occurs
      console.error('Error during registration:', error);
      Swal.fire('Error', 'An error occurred. Please try again later.', 'error')
     
    }
  };

  return (
    <>
      <Header />

      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '90vh' }}>
        <div className="row justify-content-center w-100">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4 col-xxxl-3">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-center mb-4">
                  <h4>Register Customer</h4>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="hidden"
                      className="form-control"
                      id="agentId"
                      placeholder="Agent ID"
                      value={agentId}
                      disabled // Agent ID is auto-filled from the logged-in user data
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter Customer Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="mobileNo" className="form-label">Mobile No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="mobileNo"
                      placeholder="Enter Mobile No"
                      value={mobileNo}
                      onChange={(e) => setMobileNo(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="cnic" className="form-label">CNIC</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cnic"
                      placeholder="Enter CNIC"
                      value={cnic}
                      onChange={(e) => setCnic(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">Status</label>
                    <select
                      className="form-select"
                      id="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      required
                    >
                      <option value="Transfer">Transfer</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="gender" className="form-label">Gender</label>
                    <select
                      className="form-select"
                      id="gender"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="packageId" className="form-label">Package</label>
                    <select
                      className="form-select"
                      id="packageId"
                      value={packageId}
                      onChange={(e) => setPackageId(e.target.value)}
                      required
                    >
                      <option value="">Select Package</option>
                      {packages.map(pkg => (
                        <option key={pkg.packageid} value={pkg.packageid}>
                          {pkg.packageName} in Rs.{pkg.packagePrice}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="d-grid gap-2 mt-4">
                    <button 
                      type="submit" 
                      className="btn btn-primary" 
                      disabled={loading} // Disable the button while loading
                    >
                      {loading ? (
                        <><Spinner animation="border" size="sm" /> Registering...</> // Show spinner during submission
                      ) : (
                        'Register Customer'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterCustomer;
